"use strict";

var _toConsumableArray = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrTranslator = void 0;

var base_1 = require("../common/base");

var pattern_1 = require("../common/pattern");

var OrTranslator = /*#__PURE__*/function (_base_1$Translator) {
  _inherits(OrTranslator, _base_1$Translator);

  function OrTranslator() {
    _classCallCheck(this, OrTranslator);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrTranslator).apply(this, arguments));
  }

  _createClass(OrTranslator, [{
    key: "translate",
    value: function translate(chunk, actions) {
      var _ref;

      // TODO: use Array.flat
      chunk.children = (_ref = []).concat.apply(_ref, _toConsumableArray(chunk.children));
      var expression = pattern_1.translateChildren(chunk, actions).join(" / ");
      var pattern = "(".concat(expression, ")");
      return pattern;
    }
  }]);

  return OrTranslator;
}(base_1.Translator);

exports.OrTranslator = OrTranslator;